import React, { PureComponent } from 'react';
import { createCoursePlanStyle } from './style';
import { WithStyles, withStyles, Button, Typography, Grid } from '@material-ui/core';
import { MyPATPopMenu } from '../../../../common';
import {
	MoreVert as MoreIcon
} from '@material-ui/icons';

interface CreateCoursePlanProps extends WithStyles<typeof createCoursePlanStyle> {
    classes: any,
    handleComponentSwitching?: Function
    handleNoContent?: boolean,
}
const moreMenuItems = [{
    type: 'callback',
    id: 1,
    to: '',
    img: '',
    text: 'Set Display Name',
}]
class CreateCoursePlan extends PureComponent<CreateCoursePlanProps>{
    constructor(props: CreateCoursePlanProps) {
        super(props);
    }

    renderCreateCoursePlan = () => {
        const { classes, handleComponentSwitching, handleNoContent } = this.props;
        return (
          <Grid
            container
            className={classes.similarHeader}
            justify="space-between"
            alignItems="center"
          >
            <Grid item>
              <Typography>
                Select Phase Plan of Similar Course
              </Typography>
            </Grid>

            <Grid item>
              {handleNoContent ? (
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.createCourseButton}
                  onClick={() =>
                    handleComponentSwitching &&
                    handleComponentSwitching("CreateCoursePlan")
                  }
                >
                  Create Course Plan
                </Button>
              ) : (
                ""
              )}
              {/* <MyPATPopMenu
                id="content-more-menu"
                icon={MoreIcon}
                menuItem={moreMenuItems}
                clicked={this.handleMenuItemClick.bind(this, content._id)}
              /> */}
            </Grid>
          </Grid>
        );
    };

    render = () => {
        return (
            this.renderCreateCoursePlan()
        );
    }

}

// @ts-ignore
export default withStyles(createCoursePlanStyle)(CreateCoursePlan);